import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerInitialState, basedDataReducer } from 'redux/base-reducer';

import { IEecsProduct, IEecsProductModal } from '../types/eecs-products.types';

interface EecsProductsInitialState extends BaseDataReducerInitialState<IEecsProduct> {
  selectedProduct: IEecsProduct | null;
  isNeedSaveOrder: boolean;
  currentModal: IEecsProductModal | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducer<IEecsProduct, EecsProductsInitialState>('eecs-products');

const eecsProductsInitialState: EecsProductsInitialState = {
  ...initialState,
  perPage: 100,
  selectedProduct: null,
  isNeedSaveOrder: false,
  currentModal: null,
};

export const eecsProducts = createSlice({
  name: 'eecsProducts',
  initialState: eecsProductsInitialState,
  reducers: {
    setSelectedProduct(state, action: PayloadAction<IEecsProduct | null>) {
      state.selectedProduct = action.payload;
    },
    setEecsProducts(state, action: PayloadAction<IEecsProduct[]>) {
      state.items = action.payload;
    },
    setEecsProductModal(state, action: PayloadAction<IEecsProductModal | null>) {
      state.currentModal = action.payload;
    },
    setIsNeedSaveOrder(state, action: PayloadAction<boolean>) {
      state.isNeedSaveOrder = action.payload;
    },
    clearState(state) {
      state = eecsProductsInitialState;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as EecsProductsInitialState, action);
    });
  },
});

export const EecsProductsAC = AC;
export const onEecsProductsFilter = thunks.onFilter;

export const { setSelectedProduct, setEecsProductModal, clearState, setEecsProducts, setIsNeedSaveOrder } =
  eecsProducts.actions;
